import React, { PropTypes } from "react";
import moment from "moment";
import Avatar from "components/Avatar/Avatar";
import { CPDPoints } from "components/CPDPoints";
import renderSponsors from "components/Dashboard/renderSponsors";
import renderExperts from "components/Dashboard/renderExperts";
import renderPartners from "components/Dashboard/renderPartners";

const CurrentWebinarItem = ({
  webinar: {
    webinar_title,
    start_date,
    end_date,
    sponsor,
    sponsors,
    partnerships,
    joined,
    users_join_url,
    experts,
  },
  userRole,
  user,
  subscriptionAction,
  webinar,
  isMobile,
}) => {
  const canRegister =
    userRole !== "sponsor" || user.sponsor_type === "pharmaceutical";
  if (isMobile) {
    return (
      <div className="section_previous">
        <p className="section_topic">{webinar_title}</p>
        <div className="section_info_mobile">
          <div className="section_topic_mobile">
            {webinar.vimeo_url && webinar.duration ? (
              <div>
                <p className="current_card_date">Duration</p>
                <p className="current_card_time">{webinar.duration}</p>
              </div>
            ) : (
              <div>
                <p className="current_card_date">
                  <span>
                    {moment(start_date).format("MMM DD").toUpperCase()}{" "}
                  </span>
                  {moment(start_date).format("YYYY")}
                </p>
                <p className="current_card_time">
                  {moment(start_date).format("h:mm a").toUpperCase()}
                  {" - "}
                  {moment(end_date).format("h:mm a").toUpperCase()}
                </p>
              </div>
            )}
            {webinar && webinar.document_url ? (
              <div className="col l1">
                <div className="current_points">
                  Agenda:{" "}
                  <a
                    className="download_attachment"
                    target="_blank"
                    href={webinar.document_url}
                  >
                    Download
                  </a>
                </div>
              </div>
            ) : null}
            {webinar && webinar.ppt_document_url ? (
              <div className="col l1">
                <div className="current_points">
                  Resources:{" "}
                  <a
                    className="download_attachment"
                    target="_blank"
                    href={webinar.ppt_document_url}
                  >
                    Download
                  </a>
                </div>
              </div>
            ) : null}
          </div>
          {renderExperts(experts)}
          <div className="section_sponsors_mobile">
            <div>
              {sponsors && sponsors.length && sponsors.length > 0 ? (
                <div>
                  <p>Brought to you by:</p>
                  {renderSponsors(sponsor, sponsors, false)}
                </div>
              ) : null}
            </div>
            <div className="section_sponsors_join">
              <CPDPoints webinar={webinar} />
              <div className="current_join">
                {canRegister && (
                  <button
                    href="javascript:void(0)"
                    onClick={subscriptionAction}
                  >
                    {joined || users_join_url ? "OPEN WEBINAR" : "JOIN WEBINAR"}
                  </button>
                )}
              </div>
            </div>
          </div>
          {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div className="partnership-title-mobile">
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="section_previous">
      <p className="section_topic">{webinar_title}</p>
      <div className="section_info row">
        <div className="col l3 webinar_title">
          <p className="section_previous_theme"></p>
          {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div>
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null}
        </div>
        {webinar && webinar.document_url ? (
          <div className="col l1">
            <div className="current_points">
              Agenda:
              <a
                className="download_attachment"
                target="_blank"
                href={webinar.document_url}
              >
                Download
              </a>
            </div>
          </div>
        ) : null}
        {webinar && webinar.ppt_document_url ? (
          <div className="col l1">
            <div className="current_points">
              Resources:
              <a
                className="download_attachment"
                target="_blank"
                href={webinar.ppt_document_url}
              >
                Download
              </a>
            </div>
          </div>
        ) : null}
        <div className="col l2 section_topic">
          {webinar.vimeo_url && webinar.duration ? (
            <div>
              <p className="current_card_date">Duration</p>
              <p className="current_card_time">{webinar.duration}</p>
            </div>
          ) : (
            <div>
              <p className="current_card_date">
                <span>
                  {moment(start_date).format("MMM DD").toUpperCase()}{" "}
                </span>
                {moment(start_date).format("YYYY")}
              </p>
              <p className="current_card_time">
                {moment(start_date).format("h:mm a").toUpperCase()}
                {" - "}
                {moment(end_date).format("h:mm a").toUpperCase()}
              </p>
            </div>
          )}
        </div>
        <div className="col l2">
          {sponsors && sponsors.length && sponsors.length > 0 ? (
            <div>
              <p>Brought to you by:</p>
              {renderSponsors(sponsor, sponsors, false)}
            </div>
          ) : null}
        </div>
        <div className="col l1">
          <div className="current_points">
            <CPDPoints webinar={webinar} />
          </div>
        </div>
        <div className="col l2">
          <div>
            <div className="current_join">
              {canRegister && (
                <button href="javascript:void(0)" onClick={subscriptionAction}>
                  {joined || users_join_url ? "OPEN WEBINAR" : "JOIN WEBINAR"}
                </button>
              )}
            </div>
            {/* {webinar.ext_cpd_points === 0 && webinar.int_cpd_points === 0 ? null :
              <div className="current_points">
                <CPDPoints webinar={webinar} />
              </div>
            } */}
          </div>
          <div className="click_register"></div>
        </div>
      </div>
      {renderExperts(experts)}
    </div>
  );
};

CurrentWebinarItem.propTypes = {
  webinar: PropTypes.obj,
  joinToWebinar: PropTypes.func,
  userRole: PropTypes.string,
  user: PropTypes.object,
};

export default CurrentWebinarItem;



// WEBPACK FOOTER //
// ./src/components/Dashboard/CurrentWebinars/CurrentWebinarItem.js